import { cache } from "react";

import { makeUrlParams, SearchParamsType } from "@/utils/utils";
import { ListAgenceArticlePayload, ListAgenceArticleResponse } from "./agenceArticle.types";

export const listAgenceArticle = cache(async (
  agenceId: string,
  payload?: ListAgenceArticlePayload,
): Promise<ListAgenceArticleResponse> => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/agence/${agenceId}/article${payload
      ? '?' + makeUrlParams(payload as object as SearchParamsType)
      : ''}`,
    { method: "GET", cache: 'force-cache' }
  )

  if (!response.ok) {
    throw new Error(`[listAgenceArticle] API error ${response.status} for agence ${agenceId}`)
  }

  return await response.json()
})

export const listAllAgenceArticles = cache(async (
  agenceId: string,
): Promise<ListAgenceArticleResponse> => {
  const payload: ListAgenceArticlePayload = { statut: 'published', perPage: '0', page: 1}
  return await listAgenceArticle(agenceId, payload)
})

export const showAgenceArticle = cache(async (
  agenceId: string,
  agenceArticleId: string,
) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/agences/${agenceId}/site/article/${agenceArticleId}`,
    {
      method: "GET",
      cache: 'force-cache',
      headers: {
        "content-type": "application/json",
        "accept": "application/json"
      },
    }
  )

  if (!response.ok) {
    throw new Error(`[showAgenceArticle] API error ${response.status} for article ${agenceArticleId}`)
  }

  return await response.json()
})
